import { __, prop } from 'ramda';

const PRISMIC_SIZE = {
  Large: 'large',
  Moyenne: 'medium',
  Petite: 'small',
};

export const toSize = prop(__, PRISMIC_SIZE);
